module.exports = __webpack_public_path__ + "img/wind_light.85cf593d.svg";